import React from 'react';
import block from 'bem-cn-lite';

class Status extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(event) {
        this.props.onStatusClick(this.props.status.id)
    }

    render() {
        const b = block('Status');
        const { id, name, color } = this.props.status

        const colorStyle = {
            backgroundColor: `rgb(${color})`,
            borderColor: `rgb(${color})`
        }

        return (
            <a className={b({ current: this.props.current === id })} onClick={this.handleClick}>
                <span className={b('color')} style={colorStyle}></span>
                <span className={b('name')}>{name}</span>
            </a>
        )
    }
}

export default Status